import { render, staticRenderFns } from "./selectLeechero.vue?vue&type=template&id=52912ed0&scoped=true"
import script from "./selectLeechero.vue?vue&type=script&lang=js"
export * from "./selectLeechero.vue?vue&type=script&lang=js"
import style0 from "./selectLeechero.vue?vue&type=style&index=0&id=52912ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52912ed0",
  null
  
)

export default component.exports